import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Input,
  Row,
  Select,
  Modal,
  Table,
  Tooltip,
  // Image,
  Typography,
  Switch,
  // Skeleton,
} from "antd";
import {
  SettingOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import "./index.css";
import { HeaderData, TableData } from "./data";
import { Prompt } from "react-router";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import useBeforeUnload from "../../components/Prompting";

const PurchaseReturn = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  //States data
  const [invoiceShow, setInvocieShow] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    prefix: "Prefix",
    seqNo: "",
  });

  const handleChange = (e) => {
    setPurchaseData({
      ...purchaseData,
      [e.target.name]: e.target.value,
    });
  };

  const [searchOpen, setSearchOpen] = useState(false);

  const mockVal = (str, repeat = 1) => ({
    value: str.repeat(repeat),
  });

  //Search purchase
  const [options, setOptions] = useState([]);
  const getPanelValue = (searchText) =>
    !searchText ? [] : [mockVal(searchText)];
  const onSelect = (data) => {
    console.log("onSelect", data);
  };

  useBeforeUnload({
    when: !isEmpty(options),
    message: "Are you sure you want to leave?",
  });
  //Custom Fields State values
  const [settingsFieldModal, setSettingsFieldModal] = useState(false);

  const handleOk = () => {
    setSettingsFieldModal(false);
  };
  const handleCancel = () => {
    setSettingsFieldModal(false);
  };

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Purchase Return | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid h-[450px] rounded-sm bg-[#ffffff]">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div className="flex">
              <h1 style={{
                        fontFamily: "Poppins",
                      }} className="text-[18px] mt-2 font-semibold">
                Purchase Return
              </h1>
            </div>
            <div>
              <Tooltip
                title="Easily add the Purchase Return settings"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => setSettingsFieldModal(true)}
                  className="border rounded-md ml-3 pt-2 pb-2 pl-3 pr-3 cursor-pointer"
                >
                  <SettingOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        </Col>
        {/* purchase input section with bulk actions */}
        <Col span={24} className="mt-[-50px]">
          <Row className="flex justify-between ml-4">
            <div className="flex">
              <Tooltip
                rootClassName="text-[10px]"
                title="Search by phone or name"
                placement="bottom"
              >
                {searchOpen ? (
                  <AutoComplete
                    options={options}
                    style={{
                      width: 170,
                      marginRight: "10px",
                    }}
                    onSelect={onSelect}
                    onSearch={(text) => setOptions(getPanelValue(text))}
                  >
                    <Input.Search
                      size="large"
                      placeholder="Search purchase"
                      style={
                        {
                          // height: "40px",
                        }
                      }
                      // enterButton
                    />
                  </AutoComplete>
                ) : (
                  <div
                    onClick={() => setSearchOpen(true)}
                    className="border rounded-md h-[40px] mr-3 pt-2 pb-2 pr-3 pl-3 cursor-pointer"
                  >
                    <SearchOutlined size={16} />
                  </div>
                )}
              </Tooltip>

              <Select
                style={{
                  width: 250,
                  height: 40,
                    fontFamily: "Poppins",
                }}
                placeholder="Select Days"
                options={[]}
              />
            </div>
            <div className="flex">
              <Button
                // onClick={() => {
                //   toast.success("purchase Created");
                // }} 
                style={{
                  fontFamily: "Poppins",
                }}
                className="ml-3 bg-[blueviolet] p-5 text-[white] mr-3"
              >
                <Link
                  to={{
                    pathname: "/create-purchase-return",
                  }}
                >
                  Create Purchase Return
                </Link>
              </Button>
            </div>
          </Row>
        </Col>
        <Col span={24} className="p-4 mt-[-70px]">
          <Table
            style={{
              overflow: "hidden",
            }}
            bordered
            columns={HeaderData}
            dataSource={TableData}
            sortDirections={"ascend"}
            loading={loading ? true : false}
            showSorterTooltip={"sorter-icon"}
            // rowSelection={{
            //   type: selectionType,
            //   ...rowSelection,
            // }}
            rowSelection={{}}
            // scroll={{y:210}}
          />
        </Col>
        {/* Custom fields modal */}
        <Modal
          open={settingsFieldModal}
          title="Quick Purchase Return Settings"
          onOk={handleOk}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[16px]">
                Purchase Return Prefix & Invoice Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvocieShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row className="mt-2">
                <Col span={8} className="pr-3">
                  <Typography className="mb-1">Prefix</Typography>

                  <Input
                    name="prefix"
                    value={purchaseData.prefix}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Prefix"
                    className="p-2"
                  />
                </Col>
                <Col span={8}>
                  <Typography className="mb-1">Sequence Number</Typography>

                  <Input
                    name="seqNo"
                    value={purchaseData.seqNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2"
                  />
                </Col>
                <Col span={24} className="mt-2">
                  <Typography className="mb-1">
                    Purchase Return Number:{" "}
                    {!isEmpty(purchaseData.seqNo) ? purchaseData.seqNo : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
      </Row>
      <Prompt
        when={!isEmpty(options)}
        message="Are you sure you want to leave?"
      />
      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </React.Fragment>
  );
};

export default PurchaseReturn;
